import classNames from "classnames";
import CiroTitle from "../../shared/CiroTitle";
import CiroButton, { CiroButtonStyleEnum } from "../../shared/CiroButton";
import { ArrowPathIcon } from "@heroicons/react/24/outline";

interface ICuratedSearchBuilderHeading {
  selectedPrompt: string;
  expandPrompt?: string;
  startedGeneratingFilters: boolean;
  reset: () => void;
  title: string;
}

const CuratedSearchBuilderHeading = ({
  selectedPrompt,
  expandPrompt,
  startedGeneratingFilters,
  reset,
  title,
}: ICuratedSearchBuilderHeading) => {
  return (
    <div className={classNames("w-full", "mb-4")}>
      <div className={classNames("flex", "justify-between", "w-full")}>
        <CiroTitle title={title} />
        {startedGeneratingFilters && (
          <div
            className={classNames(
              "transition-all",
              "duration-500",
              "ease-in-out",
            )}
          >
            <CiroButton
              analyticsField="Restart curated search clicked"
              style={CiroButtonStyleEnum.LOUD}
              onClick={reset}
            >
              <div className={classNames("flex", "gap-2", "items-center")}>
                <ArrowPathIcon className={classNames("w-4", "h-4")} />
                Restart
              </div>
            </CiroButton>
          </div>
        )}
      </div>
      {startedGeneratingFilters && (
        <div className={classNames("flex", "flex-col", "gap-2", "py-4")}>
          <div className={classNames("text-sm", "text-zinc-500", "italic")}>
            {selectedPrompt}
          </div>
          {expandPrompt?.trim() && (
            <div className={classNames("text-sm", "text-orange-500", "italic")}>
              {expandPrompt}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CuratedSearchBuilderHeading;
